import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { InventoryItemGroup } from 'src/app/models/results/inventory-item-group';
import { InventoryItemViewModel } from 'src/app/models/results/inventory-item-view-model';

export const AnalyticsUtility = {
  wizardStepName: {
    start: "Start Step",
    primary: "Primary Use Step",
    needToRun: "Need to Run Step",
    useCase: "Use Case Step",
    brand: "Brand Step",
    results: "Results"
  },
  filterType: {
    brand: "brand_filter",
    formFactor: "form_factor_filter",
    screenSize: "screen_size_filter",
    storage: "storage_filter",
    feature: "feature_filter",
    osType: "os_type_filter"
  }
};

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private analyticEventType = {
    back: "back_btn_click",
    continue: "continue_btn_click",
    wizardTileClick: "wizard_tile_click",
    learnMore: "learn_more_btn_click",
    checkboxClick: "filter_cb_click",
    shareResultsClick: "share_results_click",
    startOverClick: "start_over_click",
    resultsLoaded: "results_loaded",
    flexLinkClicked: "flex_link_clicked"
  };

  constructor( private analytics: AngularFireAnalytics) { }

  logCurrentPage(wizardStep: string): void {
    this.analytics.setCurrentScreen(wizardStep);
  }

  logBackBtnClick(wizardStep: string): void {
    const eventDetail = {
      wizard_step: wizardStep
    };
    this.analytics.logEvent(this.analyticEventType.back, eventDetail);
  }

  logContinueBtnClick(wizardStep: string): void {
    const eventDetail = {
      wizard_step: wizardStep
    };
    this.analytics.logEvent(this.analyticEventType.continue, eventDetail);
  }

  logWizardTileClick(tileValue: string, isSelected: boolean, wizardStep: string): void {
    const eventDetail = {
      event_type: this.analyticEventType.wizardTileClick,
      wizard_tile_is_selected: isSelected,
      wizard_step: wizardStep
    };
    // To remove _tile:
    // 1. Check if anything else is using this analytics data
    // 2. remove the "_tile"
    // 3. Update all Looker Studio filters using it
    this.analytics.logEvent(`${tileValue}_tile`, eventDetail);
  }

  logResultsLoaded(groups: InventoryItemGroup[]): void {
    let eventDetail: any = {};

    groups.forEach((group, index) => {
      let obj: any = {};
      obj[`item_mfg_${index}`] = group.primaryItem.manufactureName;
      obj[`item_mfg_part_num_${index}`] = group.primaryItem.manufacturePartNum;
      eventDetail = Object.assign(obj, eventDetail);
    });

    this.analytics.logEvent(this.analyticEventType.resultsLoaded, eventDetail);
  }

  logLearnMoreClick(device: InventoryItemViewModel): void {
    const eventDetail = {
      item_mfg_part_number: device.manufacturePartNum,
      item_material_id: device.materialID
    };

    this.analytics.logEvent(this.analyticEventType.learnMore, eventDetail);
  }

  logShareResultsClick(): void {
    const eventDetail = {
      share_results_clicked: true
    };
    this.analytics.logEvent(this.analyticEventType.shareResultsClick, eventDetail)
  }

  logStartOverClick(): void {
    const eventDetail = {
      start_over_clicked: true
    };
    this.analytics.logEvent(this.analyticEventType.startOverClick, eventDetail)
  }

  logCheckboxFilterClick(filterType: string, selection: string | number[], isSelected: boolean): void {
    const eventDetail = {
      filter_selection: selection,
      filter_is_selected: isSelected
    };
    this.analytics.logEvent(filterType, eventDetail);
  }

  flexLinkClicked(stepNumber: number){
    const eventDetail = {
      stepNumber: stepNumber
    };
    this.analytics.logEvent(this.analyticEventType.flexLinkClicked, eventDetail);
  }
}
